<template>
  <a-card :title="title" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
          :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol"
    >
      <a-form-model-item label="供应商商品ID" prop="rid" v-if="ruleForm.productSource==1">
        <a-input v-model="ruleForm.rid" disabled allowClear :maxLength="50" placeholder="请输入供应商商品ID"
                 style="max-width: 500px;"/>
      </a-form-model-item>
      <a-form-model-item label="积分商品名称" prop="productName">
        <a-input v-model="ruleForm.productName" allowClear :maxLength="100" placeholder="请输入积分商品名称"
                 style="max-width: 500px;"/>
      </a-form-model-item>
      <a-form-model-item label="商品类型" prop="productType">
        <a-select v-model="ruleForm.productType" placeholder="请选择" style="max-width: 500px;">
          <a-select-option v-for="item in typeList" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="商品图片" prop="rid" v-if="ruleForm.productSource==1">
        <img v-if='ruleForm.proImg' :src="ruleForm.proImg" alt='avatar'
             style='width: 102px;height:102px;border-radius: 6px;'/>
        <img v-else src="https://imgb.woyoubooking.com/common/img-loading-default.png" alt=''
             style='width: 102px;height:102px;border-radius: 6px;'>
      </a-form-model-item>
      <a-form-model-item label="所需费用" prop="points">
        <a-input v-model="ruleForm.points" placeholder="请输入" addon-after="积分" style="width: 200px;"/>
      </a-form-model-item>
      <a-form-model-item label="可兑库存" prop="stock">
        <a-input-number v-model="ruleForm.stock" placeholder="请输入" style="width: 200px;"/>
      </a-form-model-item>
      <a-form-model-item label="商品标签" prop="productTag">
        <a-select v-model="ruleForm.productTag" placeholder="请选择" style="max-width: 500px;">
          <a-select-option v-for="item in dataList" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div v-if="ruleForm.productSource==0">
        <a-form-model-item label="关联商品" prop="proId">
          <a-button @click="visiblePopup = true">选择</a-button>
          <span v-if="ruleForm.proId"> 商品ID：{{ ruleForm.proId }}</span>
        </a-form-model-item>
        <a-form-model-item label="关联优惠券ID" prop="couponId">
          <a-button @click="showCouponDialog = true">选择</a-button>
          <span v-if="ruleForm.couponId"> 优惠券ID：{{ ruleForm.couponId }}</span>
        </a-form-model-item>
      </div>
      <a-form-model-item label="权益须知" prop="notice">
        <a-textarea v-model="ruleForm.notice" placeholder="请输入权益须知" style="max-width: 500px;"
                    :auto-size="{ minRows: 4, maxRows: 8}"/>
      </a-form-model-item>
      <div v-if="ruleForm.productSource==1">
        <a-form-model-item label="兑换小程序AppID" prop="appId">
          <a-input v-model="ruleForm.appId" allowClear :maxLength="100" placeholder="请输入兑换小程序AppID"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="兑换小程序path" prop="appPath">
          <a-input v-model="ruleForm.appPath" allowClear :maxLength="100" placeholder="请输入兑换小程序path"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="H5兑换URL" prop="h5Url">
          <a-input v-model="ruleForm.h5Url" allowClear :maxLength="200" placeholder="请输入兑换小程序AppID"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="rightsSupplyContact">
          <a-input v-model="ruleForm.rightsSupplyContact" allowClear :maxLength="100" placeholder="请输入联系方式"
                   style="max-width: 500px;"/>
        </a-form-model-item>
        <a-form-model-item label="权益提供方" prop="rightsSupply">
          <a-input v-model="ruleForm.rightsSupply" allowClear :maxLength="100" placeholder="请输入权益提供方"
                   style="max-width: 500px;"/>
        </a-form-model-item>
      </div>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" :disabled="isDisabled" @click="handleSubmit" :loading="submitLoading">提交</a-button>
        <a-button @click="backEvent" style="margin-left: 15px;">取消</a-button>
      </a-form-model-item>
    </a-form-model>
    <!-- 商品组件弹窗 -->
    <ProductPopupView :visible="visiblePopup" @change="changeSelectPro" @cancel="handleCancel"></ProductPopupView>
    <!--关联优惠券-->
    <selected-product-dialog
      title="选择优惠券"
      :show="showCouponDialog"
      :itemNames="['search_couponName']"
      :requestPromise="loadCouponPromise"
      :queryParams="selectedParams"
      :width="900"
      ref="pageList"
      :page-size="5"
      @close="showCouponDialog = false"
      :columns="getCouponColumns()"
    >
      <a-form-item label="名称" slot="search_couponName" v-bind="selectedFormLayout">
        <a-input v-model="selectedParams.couponName" style="width: 170px" placeholder="请输入优惠券名称"></a-input>
      </a-form-item>
      <div slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="selectCouponChoose(rowItem.record)">选择</a-button>
      </div>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import ruleFormLayout from '@/utils/mixins/ruleFormMixins'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'
import ProductPopupView from '@/customComponents/productPopupView/productPopupView'

export default {
  name: 'NewIntegralPro',
  mixins: [ruleFormLayout],
  components: {
    SelectedProductDialog,
    ProductPopupView
  },
  data() {
    return {
      submitLoading: false,
      title: '',
      id: 0,
      source: 0,
      ruleForm: {
        couponGetWay: 0,
        couponId: '',// 关联优惠券id ,
        notice: '',// 权益须知 ,
        points: '',// 所需费用 ,
        proId: '',// 关联商品id ,
        productName: '',// 积分商品名称 ,
        productTag: undefined,//
        productType: undefined,// 商品类型 ,
        stock: '',// 库存
        proImg: '',
        productSource: 0
      },
      selectedFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      rules: {
        productName: [{ required: true, message: '请输入积分商品名称', trigger: 'blur' }],
        productType: [{ required: true, message: '请选择商品类型', trigger: 'change' }],
        points: [
          { required: true, message: '请输入所需费用', trigger: 'blur' },
          { pattern: /^[0-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
        ],
        productTag: [
          { required: true, message: '请选择商品标签', trigger: 'change' }
        ],
        stock: [
          { required: true, message: '请输入可兑库存', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '必须是正整数', trigger: 'blur' }
        ],
        proId: [
          { required: true, message: '请选择关联商品', trigger: ['change', 'blur'] }
        ],
        couponId: [
          { required: true, message: '请选择关联优惠券', trigger: ['change', 'blur'] }
        ],
        notice: [
          { required: true, message: '请输入权益须知', trigger: 'blur' }
        ]
      },
      visiblePopup: false,
      selectedQueryGroupParams: { groupStatus: 1, groupName: '' },
      showCouponDialog: false,
      selectedParams: {
        couponName: '',
        couponStatus: 1,
        couponMerchantId: this.$store.getters.userInfo.merchantId,
        couponPlatformId: this.getPlatformConfig().platformId
      },
      loadCouponPromise: params => this.getCouponListPromise(params),
      dataList: [],
      typeList: [],
      isDisabled: false
    }
  },
  created() {
    this.id = this.getPageParams().id
    this.source = this.getPageParams().source
    this.title = this.id != 0 ? '编辑积分商品' : '新建积分商品'
    this.getPointProductTagEnum()
    this.getPointProductTypeEnum()
    this.getProductInfo()
  },
  mounted() {
  },
  methods: {
    getPointProductTagEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/points/product/getPointProductTagEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.dataList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getPointProductTypeEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/points/product/getPointProductTypeEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.typeList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getProductInfo() {
      if (this.id && this.id != 0) {
        const params = {
          pointsProductId: this.id,
          productSource: this.source
        }
        this.getHttpServices().getIntegralApiService().post('admin/points/product/info', params).then(res => {
          this.getLogUtils().logWithTag('getProDataInfo', res)
          this.ruleForm = { ...res }
          this.isDisabled = res.productSource == 1 ? true : false
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.isDisabled = false
      }
    },
    // 选择商品
    changeSelectPro(record) {
      this.getLogUtils().logWithTag('选择商品', record)
      this.ruleForm.proId = record.proId
      this.ruleForm.proImg = record.proImg
      this.$refs.ruleForm.validateField('proId', (Error) => {
      })
      this.handleCancel()
    },
    handleCancel() {
      this.visiblePopup = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      let params = JSON.parse(JSON.stringify(this.ruleForm))
      this.getLogUtils().logWithTag('params', params)
      let path = this.id && this.id != 0 ? 'admin/points/product/update' : 'admin/points/product/save'
      this.getHttpServices().getIntegralApiService().post(path, params).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        let textStr = this.id && this.id != 0 ? '编辑' : '新建'
        this.$message.success(textStr + '积分商品成功')
        setTimeout(() => {
          this.backEvent()
        }, 800)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    getGroupRequest(params) {
      return this.getHttpServices().getProService().post('/proGroup/findProGroupList', params)
    },
    getGroupColumns() {
      return [
        {
          title: 'id',
          dataIndex: 'groupId',
          width: '60px'
        },
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    selectCouponChoose(record) {
      this.ruleForm.couponId = record.couponId
      this.ruleForm.couponGetWay = record.couponGetWay
      this.showCouponDialog = false
      this.$refs.ruleForm.validateField('couponId', (Error) => {
      })
    },
    getCouponListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getServerApiService().post('coupon/setting/getCouponSettingList', params)
    },
    //优惠券
    getCouponColumns() {
      return [
        {
          title: '优惠券Id',
          dataIndex: 'couponId',
          width: '100px'
        },
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          width: '250px'
        },
        {
          title: '优惠券金额',
          dataIndex: 'couponAmout',
          width: '140px'
        },
        {
          title: '使用类型',
          dataIndex: 'couponUseTypeStr'
        },
        {
          title: '状态',
          dataIndex: 'couponStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px',
          fixed: 'right'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.tips {
  color: rgba(51, 51, 51, 0.45);
  height: 20px;
  line-height: 20px;
}

.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}

.dynamic-delete-button:hover {
  color: #777;
}
</style>